import { z } from 'zod';
import type { ParticipantType } from '~/singlePageApp/screens/LiveStreamScreen/Broadcast/types/ParticipantType';

export type UserType = ParticipantType | 'audience';
export type UserAndRecorderType = UserType | 'recorder';

//
// HMS
//

export type Participant720pType = 'host-720p' | 'panelist-720p';
export type HmsRole = Participant720pType | UserAndRecorderType;

//
// Legacy
//
export type LegacyUserType = ParticipantType | 'audienceMember';

export const userTypeSchema = z.union([
  z.literal('host'),
  z.literal('panelist'),
  z.literal('audience'),
]);

export const legacyUserTypeSchema = userTypeSchema.or(z.literal('audienceMember'));
